import { createRoot } from 'react-dom/client';
import React from "react";
import { Provider } from "react-redux";
import { EAffiliateDialogSource } from '../react_components/dialogs/affiliate/components/AffiliateDialog/types';
import { AffiliateDialogHOC } from '../react_components/dialogs/affiliate/hocs/AffiliateDialogHOC/AffiliateDialogHOC';


App.Views.AffiliateView = App.Views.BaseView.extend({
    initialize: function (options) {
        this.root = createRoot(this.el);
        this.store = options.store;
        this.source = options.source || EAffiliateDialogSource.ONLOAD;
    },
    render: function () {
        this.root.render(
            <Provider store={this.store}>
                <AffiliateDialogHOC source={this.source} />
            </Provider>
        );
        return this;
    },
    remove: function () {
        this.root.unmount();
        Backbone.View.prototype.remove.call(this);
    }
});

export default App.Views.AffiliateView;
